module.exports = __webpack_public_path__ + "public/images/Testimonial_Audra.a1db6898cfd297ba252a360b2cbd71e9.webp";